;(function () {
  angular
    .module('contrast.vulnerabilities')
    .factory('traceRenderers', traceRenderersFactory)

  function traceRenderersFactory($, syntaxHighlighter) {
    'ngInject'

    function buildSyntaxHighlighter(language) {
      return function () {
        return function (text, render) {
          var renderedText = render(text)
          if (
            language === 'html' ||
            language === 'xml' ||
            language === 'csharp' ||
            language === 'java' ||
            language === 'javascript' ||
            language === 'ruby' ||
            language === 'python' ||
            language === 'php' ||
            language === 'go'
          ) {
            return (
              '<pre>' +
              syntaxHighlighter.highlight(renderedText, language) +
              '</pre>'
            )
          }
          return syntaxHighlighter.highlight(renderedText, language)
        }
      }
    }

    return {
      nl: '<br/>',

      //generic formatting stuff
      omitted: function () {
        return function (text, render) {
          return "<span class='omitted'>" + render(text) + '</span>'
        }
      },
      codeString: function () {
        return function (text, render) {
          return "<span class='code-string'>" + render(text) + '</span>'
        }
      },
      block: function () {
        return function (text, render) {
          return '<div>' + render(text) + '</div>'
        }
      },
      blockQuote: function () {
        return function (text, render) {
          return '<blockquote>' + render(text) + '</blockquote>'
        }
      },
      code: function () {
        return function (text, render) {
          return '<code>' + render(text) + '</code>'
        }
      },
      emphasize: function () {
        return function (text, render) {
          return '<u>' + render(text) + '</u>'
        }
      },
      exampleText: function () {
        return function (text, render) {
          return '<b>' + render(text) + '</b>'
        }
      },
      focus: function () {
        return function (text, render) {
          return '<b>' + render(text) + '</b>'
        }
      },
      header: function () {
        return function (text, render) {
          return '<h3>' + render(text) + '</h3>'
        }
      },
      link: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          text = tokens[1]
          return $('<div>').append($('<a>').attr('href', url).text(text)).html()
        }
      },
      linkExternal: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          text = tokens[1]
          return $('<div>')
            .append(
              $('<a>').attr('target', '_blank').attr('href', url).text(text)
            )
            .html()
        }
      },
      linkFocus: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          text = tokens[1]
          return $('<div>')
            .append($('<a>').attr('class', 'bold').attr('href', url).text(text))
            .html()
        }
      },
      clickMethod: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var method = tokens[0]
          text = tokens[1]
          return $('<div>')
            .append(
              $('<a>')
                .attr('style', 'cursor: pointer;')
                .attr('ng-click', method)
                .text(text)
            )
            .html()
        }
      },
      paragraph: function () {
        return function (text, render) {
          return '<p>' + render(text) + '</p>'
        }
      },
      orderedList: function () {
        return function (text, render) {
          return '<ol>' + render(text) + '</ol>'
        }
      },
      unorderedList: function () {
        return function (text, render) {
          return '<ul>' + render(text) + '</ul>'
        }
      },
      listElement: function () {
        return function (text, render) {
          return '<li>' + render(text) + '</li>'
        }
      },
      warning: function () {
        return function (text, render) {
          return "<div class='warning-text'>" + render(text) + '</div>'
        }
      },

      //tables
      table: function () {
        return function (text, render) {
          return "<table class='tbl-evidence'>" + render(text) + '</table>'
        }
      },
      tableBody: function () {
        return function (text, render) {
          return '<tbody>' + render(text) + '</tbody>'
        }
      },
      tableCell: function () {
        return function (text, render) {
          return '<td>' + render(text) + '</td>'
        }
      },
      tableCellAlt: function () {
        return function (text, render) {
          return "<td class='alt'>" + render(text) + '</td>'
        }
      },
      tableHeader: function () {
        return function (text, render) {
          return '<thead>' + render(text) + '</thead>'
        }
      },
      tableHeaderRow: function () {
        return function (text, render) {
          return '<th>' + render(text) + '</th>'
        }
      },
      tableRow: function () {
        return function (text, render) {
          return '<tr>' + render(text) + '</tr>'
        }
      },
      goodTableRow: function () {
        return function (text, render) {
          return "<tr class='good-evidence'>" + render(text) + '</tr>'
        }
      },
      badTableRow: function () {
        return function (text, render) {
          return "<tr class='bad-evidence'>" + render(text) + '</tr>'
        }
      },

      //common data types
      /* TODO TS-8732
      uri: function() {
        return function(text, render) {
          return '<i>' + render(text) + '</i>'
        }
      },*/
      unstyledData: function () {
        return function (text, render) {
          return '<span>' + render(text) + '</span>'
        }
      },
      taint: function () {
        return function (text, render) {
          return "<span class='tainted-data'>" + render(text) + '</span>'
        }
      },
      grayedData: function () {
        return function (text, render) {
          return "<span class='grayed-data'>" + render(text) + '</span>'
        }
      },
      inlineCode: function () {
        return function (text, render) {
          return "<span class='inline-code'>" + render(text) + '</span>'
        }
      },

      redacted: function () {
        return function (text) {
          return (
            '<span class="break-word"><span class="bold-important" tooltip-class="medium-tooltip tooltip-robust" tooltip-placement="bottom" uib-tooltip-template="\'views/tooltips/sensitive-data-redacted-tooltip.html\'" tooltip-trigger="hoverableOpen" tooltip-hoverable tooltip-append-to-body="true">' +
            text +
            '</span></span>'
          )
        }
      },

      //synatx highlighting for params and configs
      badConfig: function () {
        return function (text, render) {
          return "<font color='red'>" + render(text) + '</font>'
        }
      },
      badParam: function () {
        return function (text, render) {
          return "<font color='red'>" + render(text) + '</font>'
        }
      },
      goodConfig: function () {
        return function (text, render) {
          return "<font color='green'>" + render(text) + '</font>'
        }
      },
      goodParam: function () {
        return function (text, render) {
          return "<font color='green'>" + render(text) + '</font>'
        }
      },

      //syntax highlighting for code blocks
      csharpBlock: buildSyntaxHighlighter('csharp'),
      javaBlock: buildSyntaxHighlighter('java'),
      javascriptBlock: buildSyntaxHighlighter('javascript'),
      rubyBlock: buildSyntaxHighlighter('ruby'),
      pythonBlock: buildSyntaxHighlighter('python'),
      phpBlock: buildSyntaxHighlighter('php'),
      goBlock: buildSyntaxHighlighter('go'),
      htmlBlock: buildSyntaxHighlighter('html'),
      xmlBlock: buildSyntaxHighlighter('xml'),

      //risk evidence
      riskEvidence: function () {
        return function (text, render) {
          return "<pre class='trace-risk-evidence'>" + render(text) + '</pre>'
        }
      },

      unlicensed: function () {
        return function (text, render) {
          return (
            "<span class='unlicensed-vuln-title'>" + render(text) + '</span>'
          )
        }
      },

      //badges
      redBadge: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          var linkText = tokens[1]
          var link = $('<div>')
            .append(
              $('<a>').attr('class', 'bold').attr('href', url).text(linkText)
            )
            .html()
          var wrapper = $('<div>')
            .append(
              $('<div>')
                .attr('class', 'label badge-severity badge-severity-critical')
                .html(link)
            )
            .html()
          return "<div class='notification-label'>" + wrapper + '</div>'
        }
      },
      yellowBadge: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          var linkText = tokens[1]
          var link = $('<div>')
            .append(
              $('<a>').attr('class', 'bold').attr('href', url).text(linkText)
            )
            .html()
          var wrapper = $('<div>')
            .append(
              $('<div>')
                .attr('class', 'label badge-severity badge-severity-medium')
                .html(link)
            )
            .html()
          return "<div class='notification-label'>" + wrapper + '</div>'
        }
      },
      greenBadge: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          var linkText = tokens[1]
          var link = $('<div>')
            .append(
              $('<a>').attr('class', 'bold').attr('href', url).text(linkText)
            )
            .html()
          var wrapper = $('<div>')
            .append(
              $('<div>')
                .attr('class', 'label badge-severity badge-success')
                .html(link)
            )
            .html()
          return "<div class='notification-label'>" + wrapper + '</div>'
        }
      },
      defaultBadge: function () {
        return function (text, render) {
          var tokens = render(text).split('$$LINK_DELIM$$')
          var url = tokens[0]
          var linkText = tokens[1]
          var link = $('<div>')
            .append(
              $('<a>').attr('class', 'bold').attr('href', url).text(linkText)
            )
            .html()
          var wrapper = $('<div>')
            .append(
              $('<div>')
                .attr('class', 'label badge-severity badge-severity-note')
                .html(link)
            )
            .html()
          return "<div class='notification-label'>" + wrapper + '</div>'
        }
      },
      quote: function () {
        return function (text, render) {
          return "<div class='quote'>" + render(text) + '</div>'
        }
      }
    }
  }
})()
